import { render, staticRenderFns } from "./MpCopyright.vue?vue&type=template&id=09b280f8&"
import script from "./MpCopyright.vue?vue&type=script&lang=js&"
export * from "./MpCopyright.vue?vue&type=script&lang=js&"
import style0 from "./MpCopyright.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports